import { t } from "i18next"
import { FormFieldComponentEnum, FormFieldDataTypeEnum } from "../edit/UserCustomField.interfaces"

export function getFieldTypeDescription(component: string, dataType: number): string {
  switch (component) {
    case FormFieldComponentEnum.TextField:
      switch (dataType) {
        case FormFieldDataTypeEnum.String:
          return t("global.text_field", "Text field")
        case FormFieldDataTypeEnum.Number:
          return t("global.number", "Number")
        default:
          return component
      }
    case FormFieldComponentEnum.MultiTextField:
      if (dataType === FormFieldDataTypeEnum.String) return t("global.text", "Text")
      return component
    case FormFieldComponentEnum.Upload:
      if (dataType === FormFieldDataTypeEnum.BlobStorage) return t("global.file.file", "File")
      return component
    case FormFieldComponentEnum.RadioButtons:
    case FormFieldComponentEnum.Checkbox:
    case FormFieldComponentEnum.BigRadioButtons:
      if (dataType === FormFieldDataTypeEnum.Boolean) return t("global.yes_no", "Yes/No")
      return component
    case FormFieldComponentEnum.Select:
      if (dataType === FormFieldDataTypeEnum.String) return t("global.text", "Text")
      return component
    case FormFieldComponentEnum.DatePicker:
      if (dataType === FormFieldDataTypeEnum.Date) return t("global.date", "Date")
      return component
    case FormFieldComponentEnum.DateTimePicker:
      if (dataType === FormFieldDataTypeEnum.DateTime) return t("global.date_and_time", "Date and time")
      return component
    case FormFieldComponentEnum.VehiclePicker:
    case FormFieldComponentEnum.BPLStationPicker:
    case FormFieldComponentEnum.Text:
    case FormFieldComponentEnum.CardButton:
      if (dataType === FormFieldDataTypeEnum.String) return t("global.text", "Text")
      return component
    case FormFieldComponentEnum.LocationPicker:
      return t("global.location", "Location")
    default:
      return component
  }
}

export function getComponentAndDataType(name: string): {
  component: FormFieldComponentEnum
  dataType: FormFieldDataTypeEnum
} | null {
  switch (name) {
    case "Numeric":
      return { component: FormFieldComponentEnum.TextField, dataType: FormFieldDataTypeEnum.Number }
    case "Date":
      return { component: FormFieldComponentEnum.DatePicker, dataType: FormFieldDataTypeEnum.Date }
    case "Text":
      return { component: FormFieldComponentEnum.TextField, dataType: FormFieldDataTypeEnum.String }
    case "Boolean":
      return { component: FormFieldComponentEnum.Checkbox, dataType: FormFieldDataTypeEnum.Boolean }
    case "File":
      return { component: FormFieldComponentEnum.Upload, dataType: FormFieldDataTypeEnum.BlobStorage }
    default:
      return null
  }
}
